import * as React from "react";

type Props = {
  spherical: Float32Array;
  segments: number;
  active: boolean;
};

/**
 * Reviews has no 3D content — the white plate is the HTML `<section>` itself
 * (bg-white in ScrollSections), scrolling up over the decks scene like the
 * footer does. This component exists so the section participates in the
 * SectionRefs visibility toggle and FBO isolation system on equal footing
 * with the other parts.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function ReviewsPart(_props: Props) {
  return <group />;
}
